import React from 'react';
import { 
  HelpCircle, 
  TrendingUp, 
  Briefcase, 
  Calendar, 
  Landmark, 
  PiggyBank, 
  Clock, 
  Award
} from 'lucide-react';

/**
 * Компонент боковой панели с советами по пенсионному планированию
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Clock,
      title: 'Начните раньше',
      description: 'Чем раньше вы начнете формировать пенсионные накопления, тем больше они вырастут за счет сложного процента.'
    },
    {
      icon: Briefcase,
      title: 'Официальное трудоустройство',
      description: 'Только "белая" зарплата формирует ваши пенсионные права в системе обязательного пенсионного страхования.'
    },
    {
      icon: Calendar,
      title: 'Максимизируйте стаж',
      description: 'Стремитесь к непрерывному страховому стажу, учитывайте периоды ухода за детьми и службы в армии.'
    },
    {
      icon: PiggyBank,
      title: 'Диверсифицируйте накопления',
      description: 'Используйте разные инструменты: НПФ, ИИС, страхование жизни, самостоятельные инвестиции.'
    },
    {
      icon: Landmark,
      title: 'Используйте налоговые льготы',
      description: 'Получайте социальные и инвестиционные налоговые вычеты при формировании пенсионных накоплений.'
    },
    {
      icon: TrendingUp,
      title: 'Учитывайте инфляцию',
      description: 'Выбирайте инвестиционные инструменты с доходностью выше инфляции для сохранения покупательной способности.'
    },
    {
      icon: Award,
      title: 'Отложенный выход на пенсию',
      description: 'Работа после достижения пенсионного возраста увеличивает ваши пенсионные баллы и коэффициенты.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-emerald-500" />
        Советы по планированию пенсии
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-emerald-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Получите консультацию
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Для более точного планирования пенсии рекомендуем проконсультироваться со специалистом СФР или финансовым советником.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Записаться на консультацию
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;